module.exports = __webpack_public_path__ + "img/identity.7375d4ce.png";